<template>
  <div class="page-body" v-if="taskList.process">
    <div class="page-title">
      <div class="page-title-left">
        <el-button class="menu-btn" @click="$emit('openMenu')">
          <span class="line"></span>
          <span class="line"></span>
          <span class="line"></span>
        </el-button>
        <!-- {{ chosenCategory.name }} -->
      </div>
      <Filters />
    </div>
    <div class="tasks">
      <el-row :gutter="20">
        <el-col :span="20">
          <el-select
            v-model="groupId"
            placeholder="Choose group"
            @change="filterByGroup()"
            class="w-100"
            :clearable="true"
          >
            <el-option label="All" value="0" />
            <el-option
              v-for="item in groupList"
              :key="item.id"
              :label="item.title"
              :value="item.id"
            />
          </el-select>
        </el-col>
        <el-col :span="4">
          <el-button type="primary" plain @click="filterByGroup(true)">
            Reset
          </el-button>
        </el-col>
      </el-row>

      <el-divider />

      <TransitionGroup>
        <span v-for="(item, key) in taskList.process" :key="key">
          <TaskItem :item="item" />
        </span>
      </TransitionGroup>
      <el-pagination
        small
        background
        layout="prev, pager, next"
        :total="totalCount"
        class="mtb-4"
        v-model:current-page="page"
        @current-change="currentChange()"
      />

      <div class="tasks-complite">
        <TransitionGroup>
          <div class="tasks-complite__title">
            <el-icon><ArrowDownBold /></el-icon>
            Completed ({{ taskList.complite.length }})
          </div>
          <!-- <template v-if="taskList.complite.length"> -->
          <span v-for="(item, key) in taskList.complite" :key="key">
            <TaskItem :item="item" />
          </span>
          <!-- </template> -->
          <!-- <el-empty description="No complite" v-else></el-empty> -->
        </TransitionGroup>
      </div>
    </div>
  </div>

  <TaskCreate v-model="isCreateModal" @close="updateList()" />

  <GroupCreate v-model="isGroupModal" @createdGroup="updateGroupList()" />

  <TaskRoute v-model="isRouteModal" />

  <div class="add-new-task">
    <el-button-group>
      <el-button type="success" plain @click="isCreateModal = true">
        Create task
      </el-button>
      <el-button type="primary" plain @click="isGroupModal = true">
        Create group
      </el-button>
      <el-button type="warning" plain @click="isRouteModal = true">
        Route
      </el-button>
    </el-button-group>
  </div>
</template>

<script>
import ApiTask from "@/api/task";
import TaskMixin from "@/mixins/Task.mixins";
import Filters from "@/components/Common/Filters.vue";
import TaskItem from "@/components/Task/Item";
import TaskCreate from "@/components/Task/Create";
import TaskRoute from "@/components/Task/Route";
import GroupCreate from "@/components/Group/Create";
import bus from "vue3-eventbus";

import { mapGetters } from "vuex";
import _ from "lodash";
export default {
  data() {
    return {
      taskList: {
        complite: [],
        process: [],
      },
      stationList: [],
      isCreateModal: false,
      isGroupModal: false,
      isRouteModal: false,
      loading: false,
      groupId: null,
      page: 1,
      totalCount: 0,
    };
  },
  watch: {
    $route(to, from) {
      this.page = 1;
      this.getList();
    },
  },

  computed: {
    ...mapGetters("User", ["user", "groupList"]),
  },
  mixins: [TaskMixin],
  components: {
    TaskItem,
    Filters,
    TaskCreate,
    TaskRoute,
    GroupCreate,
  },
  methods: {
    filterByGroup(isClear = false) {
      const url = new URL(window.location);
      if (isClear) {
        this.groupId = null;

        this.$router.replace(`${this.$route.path}`);
        bus.emit('resetFilter')
      } else {
        if (this.groupId == 0) {
          url.searchParams.delete("filter[groupId]");
          window.history.pushState({}, "", url);

          this.$router.replace(`${this.$route.path}?${url.search}`);
        } else {
          url.searchParams.set("filter[groupId]", this.groupId);
          window.history.pushState({}, "", url);

          this.$router.replace(`${this.$route.path}?${url.search}`);
        }
      }
    },
    updateGroupList() {
      this.isGroupModal = false;
      // this.getList();
    },
    updateList() {
      this.isCreateModal = false;
      this.getList();
    },
    getList(params = {}) {
      const query = Object.assign(
        { page: this.page },
        params,
        this.$route.query
      );

      ApiTask.getTaskList(query).then((responce) => {
        this.totalCount = responce.data.count;
        this.handleTaskList(responce.data.tasks);
      });
    },
    handleTaskList(list = []) {
      this.taskList = {
        complite: [],
        process: [],
      };
      _.each(list, (item) => {
        if (item.status === "completed") {
          this.taskList.complite.push(item);

          this.taskList.complite.sort(function(x, y){return x.update - y.update})
        } else {
          this.taskList.process.push(item);
        }
      });
    },
    currentChange(value) {
      this.getList({
        page: this.page,
      });
    },
  },
  mounted() {
    this.getList();
    bus.on("compliteTask", (e) => this.getList());
  },
};
</script>

<style lang="scss" scoped>
.mtb-4 {
  margin-top: 24px;
  margin-bottom: 24px;
}
</style>